import React, { useContext } from "react";
import styled from "styled-components";
import { ClipLoader } from "react-spinners";

import Header from "./Header";
import Footer from "./Footer";
import globalContext from "../../Hooks/globalContext";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  overflow: auto;
  background-color: ${(props) => props.theme.bgColor};
  background-repeat: no-repeat;
  background-size: cover;
`;

const ContentWrapper = styled.div`
  width: 100%;
  height: calc(100% - 100px);
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: auto;
`;

const PageWrapper = ({ children, style = null, contentStyle = null }) => {
  const { user } = useContext(globalContext);
  return (
    <Wrapper style={style}>
      <Header />
      <ContentWrapper style={contentStyle}>
        {user.state ? children : <ClipLoader size={15} color="white" />}
      </ContentWrapper>
      <Footer />
    </Wrapper>
  );
};

export default PageWrapper;
